<kendo-window
    [(state)]="windowState"
    [(width)]="windowWidth"
    [(height)]="windowHeight"
    (close)="close()"
>
    <kendo-window-titlebar>
        <app-window-titlebar
            [title]="customMessagesService.translate('parametres')"
            [(state)]="windowState"
            (closeWindow)="close()"
        ></app-window-titlebar>
    </kendo-window-titlebar>
    <p>{{ customMessagesService.translate('choixCouleur') }}</p>
    <div class="theme-list">
        @for (theme of themes; track theme.value) {
            <button
                type="button"
                class="theme-button"
                [class.selected]="selectedTheme === theme.value"
                [style.background-color]="theme.color"
                [title]="theme.label"
                (click)="selectTheme(theme.value)"
            ></button>
        }
    </div>
</kendo-window>
